
import { initialBalanceState, IBalanceState } from '../state/balance.state';
import { EBalanceActions, BalanceActions } from '../actions/balance.actions';

export const balanceReducers = (
    state = initialBalanceState,
    action: BalanceActions
  ): IBalanceState => {
    switch (action.type) {
      case EBalanceActions.GetBalanceSuccess: {
        return {
          ...state,
          balance: action.payload
        };
      }
      case EBalanceActions.GetBalanceReset: {
        return {
          ...state,
          balance: null
        };
      }
      default:
        return state;
    }
  };
